import React from "react";
import { MenuItem } from "../../../models/menu";
import classes from "./context-menu.module.css";
import FormModal from "../FormModal/FormModal";
import { MdMore } from "react-icons/md";

export interface ContextMenuProps<T> {
  menu: MenuItem<T>[];
  item: T;
}

export default function ContextMenu<T>(props: ContextMenuProps<T>) {
  const listGroupItems = props.menu.map((d, index) => {
    let tempKey =
      d.name.toLowerCase().replaceAll(" ", "_") + "_" + index.toString();

    return (
      <button
        key={tempKey}
        className="list-group-item"
        disabled={d.disabled}
        onClick={() => d.onClick?.(props.item)}
      >
        {d.icon}
        {d.name}
      </button>
    );
  });
  return (
    <div className="dropdown">
      <button
        className="btn btn-sm btn-outline-secondary dropdown"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <MdMore />
      </button>
      <ul className="dropdown-menu context-menu">
        <div className="list-group">{listGroupItems}</div>
      </ul>
    </div>
  );
}
